module.exports = __webpack_public_path__ + "img/ic-calendar.58818b74.svg";